/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Rhythm_Title_LeadInputs */

const en_portal_rhythm_title_lead = /** @type {(inputs: Portal_Rhythm_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training, plan and diet`)
};

const pl_portal_rhythm_title_lead = /** @type {(inputs: Portal_Rhythm_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening, plan i dieta`)
};

/**
* | output |
* | --- |
* | "Training, plan and diet" |
*
* @param {Portal_Rhythm_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_rhythm_title_lead = /** @type {((inputs?: Portal_Rhythm_Title_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Rhythm_Title_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_rhythm_title_lead(inputs)
	return en_portal_rhythm_title_lead(inputs)
});